import {
  ArrowDown,
  ArrowDownToLine,
  ArrowUp,
  ArrowUpToLine,
  Copy,
  Maximize2,
  Pencil,
  RefreshCw,
  Trash2,
} from 'lucide-react-native';
import { memo } from 'react';
import { BiMenuRow } from '../../components/ui/BiMenuRow';
import { BiMenuSheet } from '../../components/ui/BiMenuSheet';
import { BiCardMove } from '../functions/biCardMove';

/** Moving a card from its menu, where it cannot be dragged. */
export interface BiCardMoves {
  /** First / last in reading order: the moves past that end are inert. */
  first: boolean;
  last: boolean;
  onMove: (move: BiCardMove) => void;
}

/**
 * The card's ⋯ menu: open its page, refresh it and copy its data for
 * anyone; editors also edit, move (where dragging is not offered) and
 * delete it.
 */
export const CardMenu = memo(
  ({
    visible,
    title,
    onOpen,
    onRefresh,
    onCopy,
    onEdit,
    editDisabled,
    moves,
    onRemove,
    onClose,
  }: {
    visible: boolean;
    title: string;
    onOpen: () => void;
    /** Reads the card's data again. */
    onRefresh: () => void;
    /** Copies the data behind the card; given once it has rows. */
    onCopy?: () => void;
    onEdit?: () => void;
    /** Shown but inert: the card's data, which the form starts from, loads. */
    editDisabled?: boolean;
    moves?: BiCardMoves;
    onRemove?: () => void;
    onClose: () => void;
  }) => {
    return (
      <BiMenuSheet visible={visible} title={title} onClose={onClose}>
        {run => {
          const move = (to: BiCardMove) => run(() => moves?.onMove(to));
          return (
            <>
              <BiMenuRow
                icon={Maximize2}
                label="查看详情"
                onPress={run(onOpen)}
              />
              {onEdit ? (
                <BiMenuRow
                  icon={Pencil}
                  label="编辑"
                  disabled={editDisabled}
                  onPress={run(onEdit)}
                />
              ) : null}
              {onCopy ? (
                <BiMenuRow icon={Copy} label="复制数据" onPress={run(onCopy)} />
              ) : null}
              <BiMenuRow
                icon={RefreshCw}
                label="刷新"
                onPress={run(onRefresh)}
              />
              {moves ? (
                <>
                  <BiMenuRow
                    icon={ArrowUp}
                    label="上移"
                    disabled={moves.first}
                    onPress={move(BiCardMove.Up)}
                  />
                  <BiMenuRow
                    icon={ArrowDown}
                    label="下移"
                    disabled={moves.last}
                    onPress={move(BiCardMove.Down)}
                  />
                  <BiMenuRow
                    icon={ArrowUpToLine}
                    label="移到最前"
                    disabled={moves.first}
                    onPress={move(BiCardMove.First)}
                  />
                  <BiMenuRow
                    icon={ArrowDownToLine}
                    label="移到最后"
                    disabled={moves.last}
                    onPress={move(BiCardMove.Last)}
                  />
                </>
              ) : null}
              {onRemove ? (
                <BiMenuRow
                  icon={Trash2}
                  label="删除"
                  danger
                  onPress={run(onRemove)}
                />
              ) : null}
            </>
          );
        }}
      </BiMenuSheet>
    );
  },
);
